import React, { useState, useRef, useMemo } from "react";
import { Spin, Alert as AlertAntd, Typography } from "antd";
import { ConnectedProps, connect } from "react-redux";
import { clearAlerts, listAlerts, updateAlerts } from "../../../actions";
import { ReducerState, JoinedAlert } from "../../../types";
import AlertDialog from "./AlertDialog";
import { useAppSelector } from "../../../hooks";
import { useListTrapsQuery } from "../../../actions/trapsiteInQuery";
import { useListDevicesQuery } from "../../../actions/devicesInQuery";
import { DownOutlined } from "@ant-design/icons";
import "./index.css";
import { ReactComponent as MosquitoIconSvg } from "../../../assets/icons/MosquitoVector.svg";

const { Title, Text } = Typography;

const mapStateToProps = (state: ReducerState) => {
  return {};
};

const connector = connect(mapStateToProps, {
  listAlerts,
  updateAlerts,
  clearAlerts,
});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const TrapAlert: React.FC<Props> = () => {
  const { alerts } = useAppSelector((state) => {
    const detectionAlerts = Object.values(state.alerts.alerts).filter(
      (item) => item.tag === "Detection",
    );
    return {
      alerts: detectionAlerts,
    };
  });

  const { data: trapData, isLoading: trapLoading } = useListTrapsQuery();
  const { data: devices, isLoading: devicesLoading } = useListDevicesQuery();

  const [loading] = useState(false);
  const listContainerRef = useRef<HTMLDivElement>(null);

  const joinedAlerts = useMemo(() => {
    return alerts.map((alert) => {
      const device = devices?.items?.find((d) => d.uuid === alert.device);
      const trap = trapData?.items?.find((t) => {
        return t._id === device?.trap_id;
      });
      return {
        ...alert,
        device_name: device?.display_name || "",
        trap_name: trap?.display_name || "",
      } as JoinedAlert;
    });
  }, [alerts, devices, trapData]);

  return (
    <div className="detection-box-container">
      <Spin spinning={trapLoading || devicesLoading || loading}>
        <div className="detection-box-title">
          <Title level={4} className="detection-box-title-text">
            Detections
          </Title>
          <DownOutlined className="detection-box-title-icon" />
        </div>
        <div
          ref={listContainerRef}
          className={`detection-box-alerts ${
            joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
          }`}
        >
          {joinedAlerts.length > 0 ? (
            joinedAlerts.map((item: JoinedAlert) => (
              <AlertDialog
                key={item._id}
                item={item}
                //   onClick={doUpdateAlert}
              />
            ))
          ) : (
            <AlertAntd
              message={<Text strong>No detections</Text>}
              showIcon
              type="success"
              icon={
                <MosquitoIconSvg
                  width={24}
                  height={24}
                  stroke="none"
                  fill="#22C55E"
                />
              }
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default connector(TrapAlert);
